import request from 'axios';
import partial from 'lodash/partial';
import sortBy from 'lodash/sortBy';
import { ENTRIES_RESOURCE_NAME } from 'focus_groups/constants';
import { getAPIQueryString } from 'common/utils';
import { savePageCount } from 'common/pager/ducks';

/* ACTIONS
================================================================================================ */
const FETCH_ALL = 'crowdspring/focus_groups_entries/FETCH_ALL';
const FETCH_ALL_REQUEST = 'crowdspring/focus_groups_entries/FETCH_ALL_REQUEST';
const FETCH_ALL_SUCCESS = 'crowdspring/focus_groups_entries/FETCH_ALL_SUCCESS';

const CLEAR_ALL = 'crowdspring/focus_groups_entries/CLEAR_ALL';

const SET_GROUPING = 'crowdspring/focus_groups_entries/SET_GROUPING';

/* HELPERS
================================================================================================ */
export const getEntries = (state) => {
  const { list, grouped } = state.project.focusGroups.entries;

  if (grouped) {
    return list;
  }

  /* if not grouped, return an entry copy for each revision */
  return list.reduce((acc, entry) => {
    entry.revisions.forEach(rev => acc = acc.concat({ ...entry, revisions: [rev] }));
    return acc;
  }, []);
}

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  list: [],
  isFetching: false,
  grouped: false,
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_ALL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload.results
      };
    case CLEAR_ALL:
      return {
        ...state,
        list: [],
      };
    case SET_GROUPING:
      return {
        ...state,
        grouped: action.payload
      };
    default:
      return state;
  }
}

export const fetchAll = (projectId, query) => (dispatch) => {
  const opts = {
    extraAPIQuery: {
      entry_eliminated: false,
      entry_withdrawn: false
    }
  };
  const queryStr = getAPIQueryString(ENTRIES_RESOURCE_NAME, query, opts);
  const promise = request.get(`/api/v1/projects/${projectId}/entries/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(ENTRIES_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_ALL,
    promise
  });
};

export const clearAll = () => {
  return {
    type: CLEAR_ALL,
  };
}

export const setGrouping = (grouped) => {
  return {
    type: SET_GROUPING,
    payload: grouped
  };
}



// WEBPACK FOOTER //
// ./focus_groups/ducks/entries.js